import {Component, OnInit, Input} from '@angular/core';
import {PortfolioItem} from "./portfolio-item";
import {PortfolioService} from "./portfolio.service";

@Component({
  selector: 'app-partfolio-item',
  templateUrl: './portfolio-item.component.html',
  styleUrls: ['./portfolio-item.component.css'],
  providers: [ PortfolioService]
})
export class PartfolioItemComponent implements OnInit {
  currentItem: PortfolioItem;
  height: number;
  width: number;
  constructor(
    private portfolioService: PortfolioService
  ) { }

  ngOnInit() {
    this.currentItem = this.portfolioService.getPortfolioItem();
    if (this.currentItem == null) {
      this.currentItem = this.portfolioService.getItemById(0);
      this.portfolioService.setPortfolioItem(this.currentItem.id);
    }
    this.onResize();
    this.toTheTop();
  }

  toTheTop(){
    $('html, body').animate({
      scrollTop: $('#portfolio').offset().top
    }, 500);
  };

  onResize() {
    let width = $('.wrapper').width();
    let proportion;
    if (width > 1400){
      proportion = 0.408;
    } else {
      proportion = 0.499;
    }
    this.height = width * proportion;

    if (width < $(window).height()) {
     let header = $("#header").height();
     let footer = $("#footer").height();
     let result = $(window).height() - header - footer - this.height;
      $(".plug").css("height", result);
    }
  };

  setNextItem(){
    this.portfolioService.setNext();
    this.currentItem = this.portfolioService.getPortfolioItem();
    this.toTheTop();
  };

  setPrevItem(){
    this.portfolioService.setPrev();
    this.currentItem = this.portfolioService.getPortfolioItem();
    this.toTheTop();
  };

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/portfolio/portfolio-item.component.ts